/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import { enumType } from "@pagopa/ts-commons/lib/types";
import * as t from "io-ts";

export enum OtpStatusEnum {
  "PENDING" = "PENDING",

  "EXPIRED" = "EXPIRED",

  "REJECTED" = "REJECTED",

  "COMPLETED" = "COMPLETED"
}

export type OtpStatus = t.TypeOf<typeof OtpStatus>;
export const OtpStatus = enumType<OtpStatusEnum>(OtpStatusEnum, "OtpStatus");
